import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Initialize FingerprintJS
let fpPromise = null;

const getFingerprint = async () => {
  if (!fpPromise) {
    // Initialize FingerprintJS with your public API key
    // You can get a free API key from https://fingerprintjs.com/
    fpPromise = FingerprintJS.load({
      apiKey: process.env.REACT_APP_FINGERPRINT_API_KEY || 'free'
    });
  }

  try {
    const fp = await fpPromise;
    const result = await fp.get();
    
    // Store the visitor ID in localStorage for persistence
    localStorage.setItem('visitorId', result.visitorId);
    
    return {
      visitorId: result.visitorId,
      confidence: result.confidence,
      components: result.components
    };
  } catch (error) {
    console.error('Error getting fingerprint:', error);
    
    // Fallback: generate a simple visitor ID if FingerprintJS fails
    const fallbackId = 'fallback_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('visitorId', fallbackId);
    
    return {
      visitorId: fallbackId,
      confidence: 0,
      components: {}
    };
  }
};

// Get visitor ID from localStorage or generate new one
const getVisitorId = async () => {
  const storedId = localStorage.getItem('visitorId');
  
  if (storedId) {
    return storedId;
  }
  
  const fingerprint = await getFingerprint();
  return fingerprint.visitorId;
};

// Get full fingerprint data
const getFingerprintData = async () => {
  return await getFingerprint();
};

export { getFingerprint, getVisitorId, getFingerprintData };
